/* Change this file to get your personal Portfolio */

// Summary And Greeting Section


// Commented this out because emojis arent working until "https://github.com/twitter/twemoji" fixes their extensions. Everywhere you see an emoji commented out is where I made the change as of 02/08/2023
// Make sure to check src/components/footer.js and src/components/greeting.js
// import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Pledge Davis",
  title: "Hello world! I'm Pledge",
  // subTitle: emoji(
  //   "Passionate Full Stack Software Developer with experience in building web applications with JavaScript / Reactjs / Ruby on Rails and other programming languages and frameworks."
  // ),
  subTitle: (
    "Passionate Full Stack Software Developer with experience in building web applications using JavaScript / Reactjs / Ruby on Rails and other programming languages and frameworks."
  ),
  resumeLink:
    "https://docs.google.com/document/d/1oKuF6YbkLI4N9iUDzPRW2YzToygSu048gsh78oqI2Pw/edit?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/pledgedavis",
  linkedin: "https://www.linkedin.com/in/pledge-d-davis/",
  gmail: "pledgedavis14@gmail.com",
  gitlab: "https://gitlab.com/pledgedavis",
  facebook: "https://www.facebook.com/pledge.davis.5/",
  medium: "https://pledgedavis14.medium.com/",
  stackoverflow: "https://stackoverflow.com/users/13368059/pledged?tab=profile",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section
// const skillsSection = {
//   title: "What I do",
//   subTitle: "FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
//   skills: [
//     emoji(
//       "⚡ Develop highly interactive Front end and Backend / User Interfaces for your web and mobile applications"),
//     emoji("⚡  Assemble full-Stack CRUD applications with the use of Omniauth"),
//     emoji("⚡  Conduct PHIRE code/object migrations for large PeopleSoft applications"),
//     emoji("⚡  Manage application front or backend data/code"),
//     emoji("⚡  Execute UAT testing on applications while utilizing JIRA Software")
//   ],


const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    (
      "⚡ Develop highly interactive Front end and Backend / User Interfaces for your web and mobile applications"),
    ("⚡  Assemble full-Stack CRUD applications with the use of Omniauth"),
    ("⚡  Conduct PHIRE code/object migrations for large PeopleSoft applications"),
    ("⚡  Manage application front or backend data/code"),
    ("⚡  Execute UAT testing on applications while utilizing JIRA Software")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },

    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Application Development Associate",
      company: "Accenture",
      companylogo: require("./assets/images/NewestLogo.png"),
      date: "October 2021 – Present",
      desc: "Application Development Associate",
      descBullets: [
        "Tested PeopleSoft applications for bugs and defects to then discuss with the tech team how the bugs can be fixed.",
        "Manipulated PeopleSoft data with Application Designer/PeopleTools.",
        "Utilized the agile process whenever working on a project by executing tasks in a series of sprints.",
        "Conducted daily client meetings to meet the project's end goal.",
        "Performed multiple PeopleSoft Object/Code Migrations from one environment to another."
      ]
    },
    {
      role: "Software Developer",
      company: "Hyperbloom",
      companylogo: require("./assets/images/Datajoy.png"),
      date: "May 2021 – October 2021",
      desc: "Software Developer",
      descBullets: [
        "Built cloud-based applications utilizing Amazon Web Services(AWS)",
        "Produced technical blogs on web accessibility",
        "Manipulated and configured Ec2 Instances for the cloud based application to run"
      ]
    },
    {
      role: "Customer Service Representative",
      company: "JKC Services",
      companylogo: require("./assets/images/Jkc_logo.webp"),
      date: "July 2020 – October 2021",
      desc: "Customer service representative for Home Depot/Comcast",
      descBullets: [
        "Resolved client concerns during inbound calls using Avaya, the company’s communication system",
        "Manipulated VMware Horizon to easily organize client information, ensuring shorter calls and increased client satisfaction",
        "Prevented data breaches by ensuring secure connections via VPN when interacting with clients",
        "Consistently received positive feedback from clients during post-call surveys"
      ]
    }
  ]
};




// Education Section
const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Flatiron School",
      logo: require("./assets/images/Flatiron Logo.png"),
      subHeader: "Software Engineering",
      duration: "December 2019 - January 2021",
      desc:
        "Built multiple web applications and studied Operating Systems, ...",
      descBullets: ["Fullstack Web Development"]
    },
    {
      schoolName: "Keys Gate Charter High School",
      logo: require("./assets/images/Keys gate logo.jpeg"),
      subHeader: "High School Diploma",
      duration: "August 2016 - june 2017",
      desc: "General studies"
    }
  ]
};




/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: ""
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

// const achievementSection = {
//   title: emoji("Achievements And Certifications 🏆 "),
//   subtitle: "",


const achievementSection = {
  title: ("Achievements And Certifications"),
  subtitle: "",


  achievementsCards: [
    {
      title: "Software Engineering",
      subtitle:
        "A fullstack coding bootcamp that teaches students through interactive labs, lectures, and close collaboration — shipping code and showcasing your expertise through comprehensive Portfolio Projects..",
      image: require("./assets/images/Screen Shot 2021-04-09 at 9.37.49 PM.png"),
      footerLink: [
        {
          name: "Flatiron School",
          url: "https://flatironschool.com/"
        }
      ]

      // {
      //   title: "PWA Web App Developer",
      //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      //   image: require("./assets/images/pwaLogo.webp"),
      //   footerLink: [
      //     {name: "Certification", url: ""},
      //     {
      //       name: "Final Project",
      //       url: "https://pakistan-olx-1.firebaseapp.com/"
      //     }
      //   ]
    },
    {
      title: "React-Redux Certificate",
      subtitle: "This certificate was achieved by taking a free 4 hour educational course provided by Sololearn.",
      image: require("./assets/images/Cert.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.sololearn.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Below are my technical blogs based on current languages and frameworks that I'm using.",

  blogs: [
    {
      url: "https://pledgedavis14.medium.com/the-dom-d9e4dbbf96f8",
      title: "The Dom",
      description:
        "Have you ever wondered about the process of how something is updated on the computers screen?"
    },
    {
      url:
        "https://pledgedavis14.medium.com/react-lifecycle-methods-and-hooks-6fbc2766477b",
      title: "React lifecycle methods and hooks",
      description:
        "React Hooks are a very useful feature that was recently launched in React 16.8 version."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

// const talkSection = {
//   title: "TALKS",
//   subtitle: emoji(
//     "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
//   ),


const talkSection = {
  title: "TALKS",
  subtitle: (
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

// const podcastSection = {
//   title: emoji("Podcast 🎙️"),
//   subtitle: "I LOVE TO TALK ABOUT TECHNOLOGY",

//   // Please Provide with Your Podcast embeded Link
//   podcast: [
//     "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
//   ],
//   display: false // Set false to hide this section, defaults to true
// };



const podcastSection = {
  title: ("Podcast "),
  subtitle: "I LOVE TO TALK ABOUT TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// const contactInfo = {
//   title: emoji("Contact Me ☎️"),
//   subtitle: "Discuss a project or need to reach me? My Inbox is open for all.",
//   email_address: "pledgedavis14"
// };


const contactInfo = {
  title: ("Contact Me "),
  subtitle: "Discuss a project or need to reach me? My Inbox is open for all.",
  email_address: "pledgedavis14"
};

// Twitter Section

const twitterDetails = {
  userName: "DeveloperPledge", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  techStack,
  workExperiences,
  educationInfo,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
